import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import "./index.css";
import "./main-styles.css";
import App from "./App/pages/App";
import Tour from "./App/components/Tour";
import "material-symbols";
import { loadVWO } from "./loadVWO";
loadVWO();
ReactDOM.render(_jsx(Tour, { children: _jsx(App, {}) }), document.getElementById("root"));
